export const BrazosBend_Device_Points_Config = {
  K010_BREAKER_POINTS: {
    engineeringId: 'sel_351_k010',
    points: [
      {
        label: 'Breaker Status',
        pointName: 'SUB_351_K010_BREAKER_STATUS',
      },
      {
        label: 'HZ',
        pointName: 'SUB_K010_HZ',
      },
      {
        label: 'P_V_AB',
        pointName: 'SUB_411L_P_V_AB',
      },
      {
        label: 'I_A',
        pointName: 'SUB_K010_I_A',
      },
      {
        label: 'MW_TOT',
        pointName: 'SUB_K010_MW_TOT',
      },
      {
        label: 'MVAR_TOT',
        pointName: 'SUB_K010_MVAR_TOT',
      },
    ],
  },
  K100_BREAKER_POINTS: {
    engineeringId: 'sel_351_k100',
    points: [
      {
        label: 'Breaker Status',
        pointName: 'SUB_351_K100_BREAKER_STATUS',
        displayPointAsLabelValue: false,
      },
      {
        label: 'HZ',
        pointName: 'SUB_351_K100_HZ',
        displayPointAsLabelValue: true,
      },
      {
        label: 'V_AB',
        pointName: 'SUB_351_K100_V_AB',
        displayPointAsLabelValue: true,
      },
      {
        label: 'I_A',
        pointName: 'SUB_351_K100_I_A',
        displayPointAsLabelValue: true,
      },
      {
        label: 'MW_TOT',
        pointName: 'SUB_351_K100_KW_TOT',
        displayPointAsLabelValue: true,
      },
      {
        label: 'MVAR_TOT',
        pointName: 'SUB_351_K100_KVAR_TOT',
        displayPointAsLabelValue: true,
      },
    ],
  },
  K200_BREAKER_POINTS: {
    engineeringId: 'sel_351_k200',
    points: [
      {
        label: 'Breaker Status',
        pointName: 'SUB_351_K200_BREAKER_STATUS',
      },
      {
        label: 'HZ',
        pointName: 'SUB_351_K200_HZ',
      },
      {
        label: 'V_AB',
        pointName: 'SUB_351_K200_V_AB',
      },
      {
        label: 'I_A',
        pointName: 'SUB_351_K200_I_A',
      },
      {
        label: 'MW_TOT',
        pointName: 'SUB_351_K200_KW_TOT',
      },
      {
        label: 'MVAR_TOT',
        pointName: 'SUB_351_K200_KVAR_TOT',
      },
    ],
  },
  K300_BREAKER_POINTS: {
    engineeringId: 'sel_351_k300',
    points: [
      {
        label: 'Breaker Status',
        pointName: 'SUB_351_K300_BREAKER_STATUS',
      },
      {
        label: 'HZ',
        pointName: 'SUB_351_K300_HZ',
      },
      {
        label: 'V_AB',
        pointName: 'SUB_351_K300_V_AB',
      },
      {
        label: 'I_A',
        pointName: 'SUB_351_K300_I_A',
      },
      {
        label: 'MW_TOT',
        pointName: 'SUB_351_K300_KW_TOT',
      },
      {
        label: 'MVAR_TOT',
        pointName: 'SUB_351_K300_KVAR_TOT',
      },
    ],
  },
  k011_SWITCH_POINTS: {
    engineeringId: 'k011',
    points: [
      {
        label: 'K011 Switch Status',
        pointName: 'SUB_MOS_K011_SWITCH_STATUS',
      },
    ],
  },
  k019_SWITCH_POINTS: {
    engineeringId: 'k019',
    points: [
      {
        label: 'K019 Switch Status',
        pointName: 'SUB_MOS_K019_SWITCH_STATUS',
      },
    ],
  },
};
